import {MapColoursService} from './map-colours.service';
import UniqueValueRenderer from '@arcgis/core/renderers/UniqueValueRenderer';
import ClassBreaksRenderer from '@arcgis/core/renderers/ClassBreaksRenderer';
import SimpleMarkerSymbol from '@arcgis/core/symbols/SimpleMarkerSymbol';
import HeatmapRenderer from '@arcgis/core/renderers/HeatmapRenderer';
import SizeVariable from '@arcgis/core/renderers/visualVariables/SizeVariable';
import Renderer from '@arcgis/core/renderers/Renderer';
import {MapSymbolsService, SymbolColour} from '@core/utils/engin/geospatial-viewer/renderers/map-symbols.service';
import {GeospatialEntitySymbolType} from '../../../../../pages/geospatial-viewer/model/api';

export class AssetRendererService {
    public assetPointRenderer(theme, outlineFlag?) {
        const outline = {
            color: 'white',
            width: 1,
        };
        return new UniqueValueRenderer({
            field: 'colour', // 'statusColor',
            uniqueValueInfos: MapColoursService.list(theme).map((item) => {
                return {
                    value: item.value,
                    symbol: {
                        type: 'simple-marker',
                        color: item.color,
                        outline: outlineFlag ? outline : '',
                    },
                };
            }),
        });
    }

    public assetLineRenderer(theme) {
        const r = new UniqueValueRenderer({
            field: 'colour', // 'statusColor',
            uniqueValueInfos: MapColoursService.list(theme).map((item) => {
                return {
                    value: item.value,
                    symbol: {
                        type: 'simple-line',
                        color: item.color,
                        width: 4,
                        outline: '',
                    },
                };
            }),
        });

        // For some reason, this does not work properly when added into the above block
        r.visualVariables = [
            {
                type: 'size',
                valueExpression: '$view.scale',
                // @ts-ignore
                stops: [
                    {size: 5, value: 2256}, // Smaller scale means zoomed in; bigger size
                    {size: 3, value: 18055},
                    {size: 2, value: 144447}, // Larger scale means zoomed out; smaller size
                ],
            },
        ];

        return r;
    }

    public pointLayerOverlapRenderer() {
        return new ClassBreaksRenderer({
            field: 'count',
            classBreakInfos: [
                {
                    minValue: 2,
                    maxValue: 2,
                    symbol: new SimpleMarkerSymbol({
                        color: 'transparent',
                        outline: {
                            color: 'black',
                            width: 1,
                        },
                    }),
                },
            ],
        });
    }

    /*
     * Colour based on value, size based on 'count' property.
     * - Size increases for every 10x count; min: 16px; max: 32px.
     */
    public bubbleLayerRenderer(theme: string) {
        // Keep same colour but different size based on 'count' property
        return new UniqueValueRenderer({
            field: 'colour', // 'statusColor',
            uniqueValueInfos: MapColoursService.list(theme).map((item) => {
                return {
                    value: item.value,
                    symbol: {
                        type: 'simple-marker',
                        color: item.color,
                        width: 5,
                        outline: {
                            color: 'white',
                            width: 1,
                        },
                    },
                };
            }),
            visualVariables: [
                new SizeVariable({
                    field: 'count',
                    stops: [
                        {
                            value: 1,
                            size: 12,
                        },
                        {
                            value: 10,
                            size: 16,
                        },
                        {
                            value: 100,
                            size: 20,
                        },
                        {
                            value: 1000,
                            size: 24,
                        },
                        {
                            value: 10000,
                            size: 28,
                        },
                        {
                            value: 100000,
                            size: 32,
                        },
                    ],
                }),
            ],
        });
    }

    public symbolRenderer(theme: string, symbolType: GeospatialEntitySymbolType): Renderer {
        return new UniqueValueRenderer({
            field: 'colour',
            uniqueValueInfos: MapSymbolsService.list(theme)
                .filter((item: SymbolColour) => item.type === symbolType.toString())
                .map((item: SymbolColour) => {
                    return {
                        value: item.value,
                        symbol: {
                            type: 'picture-marker',
                            url: item.symbolUrl,
                            width: '40px',
                            height: '40px',
                            color: item.color,
                            outline: {
                                color: 'white',
                                width: 1,
                            },
                        },
                    };
                }),
        });
    }
}
